function chatBotConfigFallback() {
    return {
        configs: {
            chatBotConfigs: {
                chatbotFabVariantToUse: 'pcln_bot_opener_logo_no_border_v1.1.svg'
            }
        }
    };
}
export { chatBotConfigFallback };
